"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Browser = void 0;
// tslint:disable
const BaseAvroRecord_1 = require("../../../BaseAvroRecord");
class Browser extends BaseAvroRecord_1.BaseAvroRecord {
    constructor() {
        super(...arguments);
        this.name = null;
    }
    schema() {
        return Browser.schema;
    }
    subject() {
        return Browser.subject;
    }
}
exports.Browser = Browser;
Browser.subject = "browser";
Browser.schema = {
    "type": "record",
    "name": "Browser",
    "namespace": "storyblocks.common.frontend",
    "fields": [
        {
            "name": "userAgent",
            "type": "string"
        },
        {
            "name": "language",
            "type": "string"
        },
        {
            "name": "platform",
            "type": "string"
        },
        {
            "name": "name",
            "type": [
                "null",
                "string"
            ],
            "default": null
        }
    ]
};
//# sourceMappingURL=Browser.js.map